import { useTranslations } from 'next-intl';

import { BarCategory } from './utils';

export function useTranslateCategoryName(category: BarCategory) {
  const t = useTranslations('bar');

  switch (category.name) {
    case 'wine-glasses':
      category.name = t('categoryName.wineGlasses');
      break;
    case 'bottles':
      category.name = t('categoryName.bottles');
      break;
    default:
      break;
  }
}

export function useTranslateHomeCategories(categories: {
  bar: BarCategory[];
  take_away: BarCategory[];
}) {
  for (let service in categories) {
    (categories[service] as BarCategory[]).forEach(useTranslateCategoryName);
  }
}
